<div class="row" *ngIf="!isPreview">
    <div class="col-lg-3 float-left" *ngIf="!isEdit && !isCreate">
        <div class="sidebar-listing">
            <div class="top_heading">
                <div class="col-md-10">Placeholders</div>
            </div>
            <div class="mt-2 ml-4 headingMessage">
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input type="text" pInputText placeholder="Search" [(ngModel)]="placeHolderFilter" />
                </span>
            </div>
            <hr>
            <ul>
                <li *ngFor="let comp of globalComponentArray | vdBuilderFilter:{keyword:placeHolderFilter}; let i = index"
                draggable="true" (dragend)="onDragEnd($event, comp)" >
                    <div class="placeHolderContainer">
                        <div>{{comp.stepName}} <small>(<i>{{comp.stepDescription}}</i></small>)</div>
                    </div>
                </li>
            </ul>
            <hr>
            <div class="clearfix"></div>
            <ul class="create-new">
                <li>
                    <div class="placeHolderContainer green pointer">
                        <div (click)="showNewStep()">Create New Step</div>
                        <div class="tickSign">&#10004;</div>
                    </div>
                </li>
            </ul>
        </div>
        <div class="sidebar-listing excluded" *ngIf="excludedSteps.length > 0">
            <div class="top_heading">
                <div class="col-md-10">Excluded Steps</div>
            </div>
            <ul>
                <li *ngFor="let comp of excludedSteps | vdBuilderFilter:{keyword:placeHolderFilter}; let i = index"
                       draggable="true" (dragend)="onDragEnd($event, comp)" >
                    <div class="placeHolderContainer green pointer">
                        <div>{{comp.stepName}}</div>
                        <div class="replay-icon"><i class="pi pi-replay"></i></div>
                    </div>
                </li>
            </ul>

        </div>

    </div>
    <div class="col-lg-3 float-left" *ngIf="isEdit || isCreate">
        <div class="sidebar-listing">
            <div class="top_heading">
                <div class="col-md-10" *ngIf="isEdit && !isCreateButton">Update Step Details</div>
                <div class="col-md-10" *ngIf="isCreate && isCreateButton">Create Step Details</div>
                <i class="pi pi-times mr-2" style="font-size: 1rem; color: #01A0DA; cursor:pointer;" (click)="cancelEdit()"></i>
                <!-- <p-button icon="pi pi-times" styleClass="p-button-danger"></p-button> -->
            </div>
            <form  #stepsForm="ngForm" class="w-100 m-2">
                <div class="p-fluid p-formgrid p-grid pt-2">

                    <div class="p-col-11 mt-2">
                        <label class="label-cls mb-2">Copy Contents From</label>
                        <!-- <select type="text" class="form-control" [(ngModel)]="stepCopiedFrom" name="stepCopiedFrom">
                            <option value="0">--select--</option>
                            <option *ngFor="let item of customMasterSteps" [value]="item.id">{{item.stepName}}</option>
                        </select> -->


                        <!-- New Dropdown -->
                        <input type="text" class="form-control" [(ngModel)]="currentDropdownVal" name="stepCopiedFrom" (focus)="customDropdownToggle()" />
                        <div class="customDropdown" *ngIf="customDropdown">                            
                            <ul>
                                <li (click)="selectedDropdownValue('0', 'Select')">Select</li>
                                <div  *ngFor="let item of customMasterSteps">
                                <li *ngIf="item.stepClassficiationType == 'Custom/Master'">
                                    <div (click)="selectedDropdownValue(item.id, item.stepDescription)">
                                        <p>{{item.stepName}}</p>
                                        <span>{{item.stepDescription}}</span>
                                    </div>
                                </li>
                                </div>
                            </ul>
                        </div>
                        <!-- New Dropdown -->

                    </div>

                    <div class="p-col-11 mt-2">
                        <label for="stepName" class="label-cls required mb-1">Step Label</label>
                        <input type="text" pInputText class="" name="stepName" [(ngModel)]="selectedStep.stepName" required>
                    </div>
                    <div class="p-col-11 mt-2">
                        <label for="stepDescription" class="label-cls mb-1">Step Description</label>
                        <input type="text" pInputText class="" name="stepDescription" [(ngModel)]="selectedStep.stepDescription">
                    </div>
                    <div class="p-col-11 mt-2">
                        <label for="stepApplicableTo" class="label-cls mb-2">Step Applicable To</label>
                        <select type="text" class="form-control" [(ngModel)]="selectedStep.stepApplicableTo" #refercenceCodeForApiCall name="refercenceCodeForApiCall">
                            <option value="0">--select--</option>
                            <option *ngFor="let item of stepApplicableToData" [value]="item.id">{{item.name}}</option>
                        </select>
                                             
                    </div>
                    
                    <div class="p-col-11 mt-3" *ngIf="selectedStep?.additionalConfig?.applicantTabs?.length > 0">
                        <div class="p-col marginBtmLeft" *ngFor="let tab of selectedStep.additionalConfig.applicantTabs; let i = index">
                            <div class="row p-0 m-0">
                                <div class="col p-0 m-0"><label>{{tab?.name}}</label></div>
                                <div class="col-3 p-0 m-0">
                                    <p-inputSwitch color="primary" name="{{tab.name}}"  class="pl-2" [(ngModel)]="tab.showTab" (onChange)="tab.showTab = $event.checked"></p-inputSwitch>
                                </div>                                
                                <div class="col-4 p-0 m-0">
                                    <label class="label-cls mr-1">Last Tab? </label>
                                    <p-radioButton [value]="tab.code" [(ngModel)]="selectedLastTab" name="lastTab" (onClick)="setLastTab(tab)"></p-radioButton>
                                </div>                                
                            </div>                            
                        </div>

                        <div class="row p-0 m-0">
                                <div class="col p-0 m-0"><label>Is Family?</label></div>
                                <div class="col-3 p-0 m-0">
                                    <p-inputSwitch color="primary" name="isFamily"  class="pl-2" [(ngModel)]="selectedStep.additionalConfig.isFamily" (onChange)="selectedStep.additionalConfig.isFamily = $event.checked"></p-inputSwitch>
                                </div>
                        </div> 
                        <div class="row p-0 m-0">
                            <div class="col p-0 m-0">
                                <label class="label-cls mr-1">Select the Doc Type </label>
                                <select type="text" class="form-control" [(ngModel)]="selectedStep.additionalConfig.docType" name="docType">
                                    <option value="">--select--</option>
                                    <option *ngFor="let type of docTypes" [value]="type.code">{{type.name}}</option>
                                </select>
                            </div>
                        </div>

                    </div>

                    <div *ngIf="selectedStep?.additionalConfig?.uscisStepConfig?.length > 0" class="pt-1">
                        <div class="p-col marginBtmLeft" *ngFor="let item of selectedStep?.additionalConfig?.uscisStepConfig">
                            <div class="row p-0 m-0">
                                <div class="col-11 p-0 m-0"><label>{{item?.name}}</label></div>
                                <div class="col-1 p-0 m-0">
                                    <p-inputSwitch name="{{item.name}}" [(ngModel)]="item.value" class="pl-2"></p-inputSwitch>
                                </div>
                            </div>

                            <div class="row p-0 m-0" *ngIf="item.name ==='Show Fee Calculation' && item.value">
                                <div class="p-field-checkbox ml-2">
                                    <p-checkbox binary="true" name="feeCalculation"
                                     [(ngModel)]="item.includeDependentsFee" inputId="feeCalculation"></p-checkbox>
                                    <label for="feeCalculation">Show Dependents Fees</label>
                                </div>
                            </div>

                            <div class="row p-0 m-0" *ngIf="item.name ==='Show Generate Forms' && item.value">
                                <div class="p-field-checkbox ml-2">
                                    <p-checkbox binary="true" name="showDependentForm"
                                     [(ngModel)]="item.showDependentForm" inputId="showDependentForm"></p-checkbox>
                                    <label for="showDependentForm">Show Dependents Form</label>
                                </div>
                            </div>
                            <div class="row p-0 m-0" *ngIf="item.name ==='Show Card Information' && item.value">
                                <div class="p-field-checkbox ml-2">
                                    <p-checkbox binary="true" name="includeCreditCardInfo"
                                     [(ngModel)]="item.includeCreditCardInfo" inputId="includeCreditCardInfo"></p-checkbox>
                                    <label for="includeCreditCardInfo">Show Credit Card Info</label>
                                </div>
                            </div>
                            <div class="row p-0 m-0" *ngIf="item.name ==='Show Card Information' && item.value">
                            <div class="p-field-checkbox ml-2">
                                <p-checkbox binary="true" name="includeEnotificationInfo"
                                 [(ngModel)]="item.includeEnotificationInfo" inputId="includeEnotificationInfo"></p-checkbox>
                                <label for="includeEnotificationInfo">Show E-notification</label>
                            </div>
                            </div>
                          
                        </div>
                    </div>
                    <div *ngIf="selectedStep?.additionalConfig?.generateLetterConfig?.length > 0" class="pt-1">
                        <div class="p-col marginBtmLeft">
                        <div class="col-11 p-0 m-0"><label>Paper Filing Configuration</label></div>
                        <div class="p-col marginBtmLeft" *ngFor="let item of selectedStep?.additionalConfig?.generateLetterConfig">
                            <div class="row p-0 m-0">
                                <div class="col-11 p-0 m-0"><label>{{item?.name}}</label></div>
                                <div class="col-1 p-0 m-0">
                                    <p-inputSwitch name="{{item.name}}" [(ngModel)]="item.value" class="pl-2"></p-inputSwitch>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                    <div *ngIf="selectedStep?.additionalConfig?.generateEfilingLetterConfig?.length > 0" class="pt-1">
                    <div class="p-col marginBtmLeft">
                        <div class="col-11 p-0 m-0"><label>Efiling Configuration</label></div>
                        <div class="p-col marginBtmLeft" *ngFor="let item1 of selectedStep?.additionalConfig?.generateEfilingLetterConfig;let i=index">
                            <div class="row p-0 m-0">
                                <div class="col-11 p-0 m-0"><label>{{item1?.name}}</label></div>
                                <div class="col-1 p-0 m-0">
                                    <p-inputSwitch name="{{item1.name}}_{{i}}" [(ngModel)]="item1.value" class="pl-2"></p-inputSwitch>
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>

                    <div class="p-col-11 mt-3" align="end">
                        <label for="selectall" class="select-all">{{(selectAll)?'uncheck all':'check all'}}</label>
                        <p-checkbox binary="true" inputId="selectall" style="visibility:hidden" name="selectall"
                        [(ngModel)]="selectAll" (onChange)="selectAllOptions($event)"></p-checkbox>
                    </div>
                    <div class="p-col-11 mt-2">
                        <label class="label-cls required mb-2">Viewable for</label>
                        <div class="p-field-checkbox ml-2"> 
                            <p-checkbox binary="true" name="petitioner"
                             [trueValue]="1" [falseValue]="0" [(ngModel)]="selectedStep.isPetitionerVisible"></p-checkbox>
                            <label for="petitioner">Petitioner</label>
                        </div>

                        <div class="p-field-checkbox ml-2">
                            <p-checkbox binary="true" name="beneficiary" [trueValue]="1" [falseValue]="0" [(ngModel)]="selectedStep.isBeneficiaryVisible" inputId="beneficiary"></p-checkbox>
                            <label for="beneficiary">Beneficiary</label>
                        </div>
                        <div class="p-field-checkbox ml-2">
                            <p-checkbox binary="true" name="attorney" [trueValue]="1" [falseValue]="0" [(ngModel)]="selectedStep.isAttorneyVisible" inputId="attorney"></p-checkbox>
                            <label for="attorney">Lawfirm</label>
                        </div>
                    </div>
                    <div class="p-col-11 m-2" style="border:1px solid #0000001a">
                        <label class="label-cls required mb-2">Actionable for</label>
                        <div class="p-field-checkbox ml-2">
                            <p-checkbox binary="true" name="pa"  (onChange)="changeActionable($event,'pa')"
                            [trueValue]="1" [falseValue]="0" [(ngModel)]="selectedStep.actionNotifyFlag[0].isPetnrAtrnyActionable" inputId="pa"></p-checkbox>
                            <label for="pa">Petitioner & Lawfirm</label>
                        </div>
                        <label class="label-cls mb-2">Notify</label>
                        <div class="p-field-checkbox ml-2">
                            <p-checkbox binary="true" name="notify1" [disabled]="!selectedStep.actionNotifyFlag[0].isPetnrAtrnyActionable" [trueValue]="1" [falseValue]="0" [(ngModel)]="selectedStep.actionNotifyFlag[0].isPetitionerNotify" inputId="notify1"></p-checkbox>
                            <label for="notify1">Petitioner</label>
                        </div>
                        <div class="p-field-checkbox ml-2">
                            <p-checkbox binary="true" name="notify2" [disabled]="!selectedStep.actionNotifyFlag[0].isPetnrAtrnyActionable" [trueValue]="1" [falseValue]="0" [(ngModel)]="selectedStep.actionNotifyFlag[0].isBeneficiaryNotify" inputId="notify2"></p-checkbox>
                            <label for="notify2">Beneficiary</label>
                        </div>
                        <div class="p-field-checkbox ml-2">
                            <p-checkbox binary="true" name="notify3" [disabled]="!selectedStep.actionNotifyFlag[0].isPetnrAtrnyActionable" [trueValue]="1" [falseValue]="0" [(ngModel)]="selectedStep.actionNotifyFlag[0].isAttorneyNotify" inputId="notify3"></p-checkbox>
                            <label for="notify3">Lawfirm</label>
                        </div>
                    </div>
                    <div class="p-col-11 m-2"  style="border:1px solid #0000001a">
                        <label class="label-cls mb-2">Actionable for</label>
                        <div class="p-field-checkbox ml-2">
                            <p-checkbox binary="true" name="notify4" (onChange)="changeActionable($event,'bene')"
                            [trueValue]="1" [falseValue]="0" [(ngModel)]="selectedStep.actionNotifyFlag[1].isBeneficiaryActionable" inputId="notify4"></p-checkbox>
                            <label for="notify4">Beneficiary</label>
                        </div>
                        <label class="label-cls  mb-2">Notify</label>
                        <div class="p-field-checkbox ml-2">
                            <p-checkbox binary="true" name="notify5" [disabled]="!selectedStep.actionNotifyFlag[1].isBeneficiaryActionable" [trueValue]="1" [falseValue]="0" [(ngModel)]="selectedStep.actionNotifyFlag[1].isPetitionerNotify" inputId="notify5"></p-checkbox>
                            <label for="notify5">Petitioner</label>
                        </div>
                        <div class="p-field-checkbox ml-2">
                            <p-checkbox binary="true" name="notify6" [disabled]="!selectedStep.actionNotifyFlag[1].isBeneficiaryActionable" [trueValue]="1" [falseValue]="0" [(ngModel)]="selectedStep.actionNotifyFlag[1].isBeneficiaryNotify" inputId="notify6"></p-checkbox>
                            <label for="notify6">Beneficiary</label>
                        </div>
                        <div class="p-field-checkbox ml-2">
                            <p-checkbox binary="true" name="notify7" [disabled]="!selectedStep.actionNotifyFlag[1].isBeneficiaryActionable" [trueValue]="1" [falseValue]="0"  [(ngModel)]="selectedStep.actionNotifyFlag[1].isAttorneyNotify" inputId="notify7"></p-checkbox>
                            <label for="notify7">Lawfirm</label>
                        </div>
                    </div>
                </div>
                <div class="p-fluid p-formgrid p-grid pt-2 pl-2" *ngIf="isEditVisa">
                    <button type="submit" class="btn vdCreateBtn mr-3" (click)="updateStepsData()" *ngIf="isEdit && !isCreateButton" [disabled]="!(selectedStep.isPetitionerVisible || selectedStep.isBeneficiaryVisible || selectedStep.isAttorneyVisible) || selectedStep.stepName =='' || !(selectedStep.actionNotifyFlag[0].isPetnrAtrnyActionable || selectedStep.actionNotifyFlag[1].isBeneficiaryActionable)">UPDATE STEP INFO</button>
                    <button type="submit" class="btn vdCreateBtn mr-3" (click)="addStepsData()"  *ngIf="isCreate && isCreateButton" [disabled]="!(selectedStep.isPetitionerVisible || selectedStep.isBeneficiaryVisible || selectedStep.isAttorneyVisible) || selectedStep.stepName =='' || !(selectedStep.actionNotifyFlag[0].isPetnrAtrnyActionable || selectedStep.actionNotifyFlag[1].isBeneficiaryActionable)">CREATE STEP INFO</button>
                </div> 
            </form>
        </div>
        <div class="row" (click)="deleteStep()" *ngIf="isEditVisa">
            <div class="col delete-container m-4">
                <i class="pi pi-trash mr-2"></i>Delete Step
            </div>
        </div>
    </div>


    <div [ngClass]="{'col-lg-12': user == true,'col-lg-9 float-right': user == false}">
        <div class="rightside-panel"  id="dataPanel"  cdkDropList (cdkDropListDropped)="drop($event)">
            <div class="top_heading">
                <div class="col-md-10" >Drag & drop required fields & sections from list</div>
                <div class="col-md-2 text-right pointer" (click)="isPreview=true;"><span>&#10094;</span>Preview</div>
            </div>
            <div class="row m-2 drag-drop-col">
                <div class="col-12 npTemplate" *ngIf="htmlRenderObj?.length == 0">Hey, You have not set any template, You can drag from list and drop here...</div>
                <div class="col-12"  *ngIf="htmlRenderObj?.length > 0">
                    <div  class="row mt-4" *ngFor="let _data of htmlRenderObj; let i = index;" cdkDrag >
                        <div class="col-1" align="center">
                           <div class="index" *ngIf="_data.id">{{i + 1}}</div> 
                           <div class="index newStep" *ngIf="!_data.id">{{i + 1}}</div>
                        </div>

                        <div class="col-10 customContainer">
                               <div class="heading">{{_data.stepName}}</div>
                               <div class="move-icon"></div>
                        </div>

                        <!-- <span class="customAction" [class.hide-display]="_data?.uiLocked===true && _data.layoutCode!== 'USCIS_CONTENT'">  -->
                        <span class="customAction">     
                            <i class="pi pi-pencil customPadding float-left" style="color: #01A0DA;cursor:pointer;"  (click)="editStep(_data, i);" title="Edit Step"></i>
                            <!-- <i class="pi pi-trash customPadding float-left" *ngIf="!_data?.uiLocked" style="color: #01A0DA; cursor:pointer;" (click)="confirmDelete(i)" title="Delete"></i> -->
                            <i class="pi pi-trash customPadding float-left" style="color: #01A0DA; cursor:pointer;" *ngIf="isEditVisa" (click)="confirmDelete(i)" title="Delete"></i>
                            <i class="pi pi-plus customPadding float-left" style="color: #01A0DA; cursor:pointer;" (click)="addCustomSteps(i)" *ngIf="!_data?.uiLocked && !_data.id" title="Add Components"></i>
                            <i *ngIf="_data.stepClassficiationType===customMasterType && !_data?.uiLocked" class="pi pi-eye customPadding float-left" style="color: #01A0DA; cursor:pointer;" (click)="openStepView()" title="View Step"></i>
                        </span>
                     
                   </div>
                </div>
            </div>
            <div class="row m-2" *ngIf="isEditVisa">
                <div class="col-12 drag-drop-col customContainer add-new">
                    <div class="heading add-new" (click)="createNewStep()">Create New Step</div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-12 mt-4">
        <p-divider type="dashed"></p-divider>
        <div class="buttonContainer my-2">
        <div> <button type="button" class="btn vdCancelBtn mr-3" (click)="hadleCancel()">CANCEL</button></div>
        <div> <button type="submit" *ngIf="!isView" class="btn vdCreateBtn mr-3" (click)="nextStep('save')">NEXT</button></div>
        <div> <button type="submit" *ngIf="isView" class="btn vdCreateBtn mr-3" (click)="onNext()">NEXT</button></div>    
    </div>
    </div>
    <p-confirmDialog header="Delete"></p-confirmDialog>


</div>
<div class="row mb-4" *ngIf="isPreview">
    <div class="col-12 rightside-panel pointer">
        <div class="top_heading">
            <div class="col-md-10" (click)="isPreview=false;"><span>&#10095;</span>Preview Timeline Steps</div>
            <!-- <div class="col-md-2 text-right" (click)="isPreview=false;"><span>&#10094;</span>Back</div> -->
        </div>
        <app-vd-builder-preview-steps [inputStepList]="htmlRenderObj"></app-vd-builder-preview-steps>
    </div>
</div>

<p-dialog header=" &nbsp;" [(visible)]="displayStepView" [style]="{width: '70vw'}" [baseZIndex]="10000" >
    <app-vd-steps-form-preview [htmlRenderObj]="htmlComponentBinding"></app-vd-steps-form-preview>
</p-dialog>
